module.exports = __webpack_public_path__ + "img/Buildings@1x.bf03401b.svg";